import React from 'react';
import { useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import { FaUserCircle, FaCog, FaQuestionCircle, FaSignOutAlt } from 'react-icons/fa';

export const HeaderUserMenu = ({ onOpenHelp, onLogout }) => {
  const navigate = useNavigate();

  return (
    <Dropdown align="end" className="bry-header-dropdown">
      <Dropdown.Toggle
        variant="link"
        className="p-0 d-flex align-items-center bry-avatar-toggle border-0"
        id="dropdown-user-menu"
      >
        <div
          className="bry-avatar rounded-circle d-flex align-items-center justify-content-center"
          style={{
            width: '38px',
            height: '38px',
            backgroundColor: 'rgba(14, 171, 176, 0.12)',
            border: '1.5px solid var(--bry-accent, #0EABB0)',
            color: 'var(--bry-accent, #0EABB0)'
          }}
        >
          <FaUserCircle size={22} />
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="bry-dropdown-menu shadow border" style={{ backgroundColor: '#ffffff', borderColor: '#cbd5e1' }}>
        <Dropdown.Item onClick={() => navigate('/perfil')} className="text-dark">
          <FaUserCircle className="me-2" style={{ color: 'var(--bry-accent, #0EABB0)' }} /> Mi Perfil
        </Dropdown.Item>
        <Dropdown.Item onClick={() => navigate('/config')} className="text-dark">
          <FaCog className="me-2" style={{ color: 'var(--bry-accent, #0EABB0)' }} /> Configuración
        </Dropdown.Item>
        <Dropdown.Item onClick={onOpenHelp} className="text-dark">
          <FaQuestionCircle className="me-2" style={{ color: 'var(--bry-accent, #0EABB0)' }} /> Soporte
        </Dropdown.Item>
        <Dropdown.Divider style={{ borderColor: '#e2e8f0' }} />
        <Dropdown.Item onClick={onLogout} className="text-danger">
          <FaSignOutAlt className="me-2" /> Salir
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default HeaderUserMenu;
